window.favoriteButtonHandler = function favoriteButtonHandler(productId) {
  return {
    isFavorited: false,
    init() {
      this.isFavorited = this.checkIfFavorited();
    },
    getFavorites() {
      try {
        return JSON.parse(localStorage.getItem('favorites')) || [];
      } catch (error) {
        return [];
      }
    },
    checkIfFavorited() {
      return this.getFavorites().includes(productId);
    },
    addToFavorites() {
      const favorites = this.getFavorites();
      if (!favorites.includes(productId)) favorites.push(productId);
      localStorage.setItem('favorites', JSON.stringify(favorites));
      this.isFavorited = true;
      this.refreshCount(favorites);
    },
    removeFromFavorites() {
      const favorites = this.getFavorites().filter((favoriteId) => favoriteId !== productId);
      localStorage.setItem('favorites', JSON.stringify(favorites));
      this.isFavorited = false;
      this.refreshCount(favorites);
    },
    refreshCount(favorites) {
      if (window.Alpine && Alpine.store('favorites')) {
        Alpine.store('favorites').count = favorites.length;
      }
    }
  };
};
